import { ClassName } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { HeaderDialog, IconButton, Panel, PanelContent } from 'components';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import ManageCertificationsFilter from '../ManageCertificationsFilter/ManageCertificationsFilter';
import ManageCertificationsTable from '../ManageCertificationsTable/ManageCertificationsTable';
import { ListIcon } from 'assets/icons';
import './ManageCertificationsDialog.scss';

export interface IManageCertificationsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  className?: ClassName;
}

const ManageCertificationDialog = (props: IManageCertificationsDialogProps) => {
  const { isOpen, onClose, className } = props;

  const filterDetails = useOpenable({ isOpen: true });

  const classes = classNames('manage-certifications-dialog', className);

  return (
    <HeaderDialog
      title={t('Manage Certifications')}
      isOpen={isOpen}
      onClose={onClose}
      size={'full'}
      showBackArrowAsClose={true}
      rightContent={<IconButton svg={ListIcon} onClick={filterDetails.toggle} className="no-print" />}
      marginRightContent={false}
      className={classes}
    >
      <PanelContent>
        <Panel>
          <ManageCertificationsTable />
        </Panel>
        <Panel medium={true} strokeLeft={true} className="no-print" open={filterDetails.isOpen}>
          <ManageCertificationsFilter />
        </Panel>
      </PanelContent>
    </HeaderDialog>
  );
};

export default ManageCertificationDialog;
